import PhotoProfileDefault from "./PhotoProfileDefault";
export default PhotoProfileDefault;
